export enum Roles {
  perfil_completo = 39,
  medico_contralor = 100,
  comision_medica = 101,
  miembro_junta = 102,
  gestion_compin = 103,
  funcionario = 42,
}

export default Roles;
